const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  REGISTER: 'user/REGISTER',
  UPDATE_PROFILE: 'user/UPDATE_PROFILE',
}

export default actions
